<template>
    <div class="row">
        <div class="col-sm-12 d-flex flex-row">
            <div class="mx-3">
                <button class="btn-custom btn-custom-send" @click.prevent="save" v-if="showSaveBtn">
                    <img class="mr-3 mb-1" src="@/assets/svg/save-ffffff.svg">
                    <span class="mr-5 text-uppercase">{{ $t('general.save') }}</span>
                </button>
            </div>
            <div class="mx-3">
                <button class="btn-custom btn-custom-save" @click.prevent="done" v-if="showDoneBtn">
                    <img class="mr-3 mb-1" src="@/assets/svg/white-check.svg">
                    <span class="mr-5 text-uppercase">{{ $t('general.done') }}</span>
                </button>
            </div>
            <div class="mx-3">
                <button class="btn-custom btn-custom-save" @click.prevent="clone" v-if="showCloneBtn">
                    <img class="mr-3 mb-1" src="@/assets/svg/white-check.svg">
                    <span class="mr-5 text-uppercase">{{ $t('general.clone') }}</span>
                </button>
            </div>
            <div class="ml-auto">
                <router-link :to="{ path: closeLink }">
                    <button type="button" class="close">&nbsp;</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    closeLink: {
      default: '/',
      type: String,
      required: false
    },
    showSaveBtn: {
      default: true,
      type: Boolean,
      required: false
    },
    showDoneBtn: {
      default: true,
      type: Boolean,
      required: false
    },
    showCloneBtn: {
      default: true,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {}
  },
  methods: {
    save () {
      this.$emit('save')
    },
    done () {
      this.$emit('done')
    },
    clone () {
      this.$emit('clone')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/TopModalButtons.vue